import AnalyticsGoogle from "./AnalyticsGoogle";
import AnalyticsInternal from "./AnalyticsInternal";
import AnalyticsProvider from "./AnalyticsProvider";

const Analytics = { };

Analytics._initialised = false;
Analytics._provider = __ANALYTICS_CONFIG.provider;

// Process event queue.
Analytics._eventQueue = [];
Analytics._processEventQueue = () => {
	for (let i = 0; i < Analytics._eventQueue.length; i++) {
		Analytics._eventQueue[i]();
	}
	Analytics._eventQueue = [];
};

// Logging
Analytics._verbose = true;
Analytics._log = (...args) => {
	if (Analytics._verbose) {
		console.log.apply(console, args); // eslint-disable-line
	}
};

Analytics.init = () => {
	Analytics._log("Analytics: initialising...", Analytics._provider);

	// ^AG: This is not done particuarly elegantly, but:
	// * I doubt we'll change analytics soon, and
	// * I doubt we'll modularise this across Geollect projects either...?
	// So it is what it is!

	if (Analytics._provider === AnalyticsProvider.ALL) {
		AnalyticsInternal.init();
		AnalyticsGoogle.init();
	}
	else if (Analytics._provider === AnalyticsProvider.INTERNAL) {
		AnalyticsInternal.init();
	}
	else if (Analytics._provider === AnalyticsProvider.GOOGLE) {
		AnalyticsGoogle.init();
	}
};

Analytics.isInitialised = () => {
	return Analytics._initialised;
};
Analytics.getProvider = () => {
	return Analytics._provider;
};

Analytics.set = (data) => {
	// If it's not initialised and we send an event, try again on initialisation.
	if (!Analytics._initialised) {
		Analytics._log("Analytics: set (DELAYED!)", data);
		Analytics._eventQueue.push(() => {
			Analytics.set(data);
		});
		return;
	}

	if (Analytics._provider === AnalyticsProvider.ALL) {
		AnalyticsInternal.set(data);
		AnalyticsGoogle.set(data);
	}
	else if (Analytics._provider === AnalyticsProvider.INTERNAL) {
		AnalyticsInternal.set(data);
	}
	else if (Analytics._provider === AnalyticsProvider.GOOGLE) {
		AnalyticsGoogle.set(data);
	}
};

// TODO: TypeScript, c'mon!
// data: { event_category: null, event_label: null, value:null };
Analytics.event = (action, data = null) => {
	// If it's not initialised and we send an event, try again on initialisation.
	if (!Analytics._initialised) {
		Analytics._log("Analytics: event (DELAYED!)", action, data);
		Analytics._eventQueue.push(() => {
			Analytics.event(action, data);
		});
		return;
	}

	if (Analytics._provider === AnalyticsProvider.ALL) {
		AnalyticsInternal.event(action, data);
		AnalyticsGoogle.event(action, data);
	}
	else if (Analytics._provider === AnalyticsProvider.INTERNAL) {
		AnalyticsInternal.event(action, data);
	}
	else if (Analytics._provider === AnalyticsProvider.GOOGLE) {
		AnalyticsGoogle.event(action, data);
	}
};

export default Analytics;
